// extracted by extract-css-chunks-webpack-plugin
module.exports = {"item":"styles__item___1AiJv"};
    if(module.hot) {
      // 1778083494813
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  